import React, { useContext, useEffect, useMemo, useState } from 'react';
import { observer } from 'mobx-react-lite';
import useMap from '@unmapped/core-ui/hooks/useMap';
import { decorateName } from '@unmapped/core/utils';
import GoogleMaps from '@unmapped/core-ui/GoogleMaps';
import useResult from '@unmapped/core/hooks/useResult';
import Popover from '@unmapped/core-ui/GoogleMaps/Popover';
import Uber2017Theme from '@unmapped/core-ui/GoogleMaps/themes/Uber2017';
import clusterIconSVG from './cluster-marker.svg?notReact';
import resultMarkerIconSVG from './result-marker.svg?notReact';
import { FocusedLocationContext, useIsMobile } from '../hooks';
import { GOOGLE_MAPS_API_KEY } from '../../apiConfig';
const scale = 1.5;
const markerDims = {
  width: 18,
  height: 24
};
const markerScaled = {
  width: markerDims.width * scale,
  height: markerDims.height * scale
};
const clusterDims = {
  width: 18,
  height: 24
};
const clusterScaled = {
  width: clusterDims.width * scale,
  height: clusterDims.height * scale,
  labelOffset: {
    x: 8.5 * scale,
    y: 9.5 * scale
  }
};
const PopoverWrapper = decorateName(observer(({
  clusters,
  popoverXOffset
}) => {
  const {
    focusedLocation,
    setFocusedLocation
  } = useContext(FocusedLocationContext);
  const {
    isExcluded
  } = useResult(focusedLocation ? focusedLocation.id : null);
  useEffect(() => {
    if (focusedLocation && isExcluded) setFocusedLocation(null);
  }, [isExcluded, focusedLocation]);
  if (!focusedLocation) return null;
  const cluster = clusters[focusedLocation.id];
  const position = cluster && cluster.position;
  return /*#__PURE__*/React.createElement(Popover, {
    result: focusedLocation,
    position: position,
    showHeading: false,
    onDismiss: () => setFocusedLocation(null),
    yOffset: 8,
    xOffset: popoverXOffset,
    arrowProps: {
      base: 16,
      length: 6
    }
  });
}), 'PopoverWrapper');
export const MapWrapper = () => {
  const {
    map,
    isLoaded
  } = useMap();
  const {
    focusedLocation,
    setFocusedLocation
  } = useContext(FocusedLocationContext);
  const [markerIcon, setMarkerIcon] = useState(undefined);
  const [clusterMarkerIcon, setClusterMarkerIcon] = useState(undefined);
  const [clusterIndex, setClusterIndex] = useState({});
  const isMobile = useIsMobile();
  const popoverXOffset = useMemo(() => isMobile ? '-50%' : '-10%', [isMobile]);
  useEffect(() => {
    if (!isLoaded || !map) return;
    if (!markerIcon) {
      setMarkerIcon({
        url: resultMarkerIconSVG,
        scaledSize: new google.maps.Size(markerScaled.width, markerScaled.height)
      });
      setClusterMarkerIcon({
        url: clusterIconSVG,
        scaledSize: new google.maps.Size(clusterScaled.width, clusterScaled.height),
        labelOrigin: new google.maps.Point(clusterScaled.labelOffset.x, clusterScaled.labelOffset.y)
      });
    }
    if (focusedLocation) {
      const resultLatLng = new google.maps.LatLng(focusedLocation.lat, focusedLocation.lng);
      const bounds = map.getBounds();
      if (!bounds) return;
      // if (!bounds.contains(resultLatLng)) {
      map.panTo(resultLatLng);
      map.panBy(0, 200);

      // }
    }
  }, [!!map, focusedLocation && focusedLocation.id]);
  return /*#__PURE__*/React.createElement(GoogleMaps, {
    showMarkers: !!markerIcon,
    markerIcon: markerIcon,
    mapStyles: Uber2017Theme,
    clusterMarkers: true
    // clusterMarkers={false}
    ,
    onClusterUpdate: idx => setClusterIndex(idx),
    clustererProps: {
      markerIcon: clusterMarkerIcon,
      label: {
        color: '#000',
        fontSize: '12px'
      }
    },
    onMarkerClick: r => setFocusedLocation(r),
    apiKey: GOOGLE_MAPS_API_KEY
  }, /*#__PURE__*/React.createElement(PopoverWrapper, {
    clusters: clusterIndex,
    popoverXOffset: popoverXOffset
  }));
};
export default MapWrapper;